import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/slideUpModal.css';

const SlideUpModal = ({ onClose, isModalOpen, customStyles = {}, hasTransparentBackdrop = false, children }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className={`modalContainer ${!isModalOpen ? ' isClosed' : ''}`}>
      <div className={`modalInnerContainer ${!isModalOpen ? ' isClosed' : ''}`} style={{ ...customStyles }}>
        {children}
      </div>
      <div
        className={`modalBackdrop ${hasTransparentBackdrop ? 'hasTransparentBackdrop' : ''}`}
        onClick={onClose}
      ></div>
    </div>
  );
};

SlideUpModal.propTypes = {
  onClose: PropTypes.func,
  isModalOpen: PropTypes.bool,
  customStyles: PropTypes.object,
  hasTransparentBackdrop: PropTypes.bool,
  children: PropTypes.any
};

export default SlideUpModal;
